import { ResponsiveButtonPrimary } from 'components/PositionList/styled'
import styled from 'styled-components'
import { StyledInternalLink } from 'theme'

const PortfolioButton = styled(ResponsiveButtonPrimary)`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 12px;
  `}
`

const PrimaryButton = styled(PortfolioButton)`
  background-color: var(--color-kodiak-button-primary);
  border: 1px solid var(--color-kodiak-button-primary);
  color: white;

  &:hover {
    background-color: var(--color-kodiak-brand-secondary);
    border-color: var(--color-kodiak-brand-secondary);
  }
`

interface CTAConfig {
  label: string
  to?: string
  onClick?: () => void
  variant?: 'primary' | 'secondary'
  disabled?: boolean
}

interface PositionCTAsProps {
  primaryCTA: CTAConfig
  secondaryCTA?: CTAConfig
  className?: string
}

export function PositionCTAs({ primaryCTA, secondaryCTA, className = '' }: PositionCTAsProps) {
  const PrimaryCTAButton = primaryCTA.variant === 'primary' ? PrimaryButton : PortfolioButton
  const SecondaryCTAButton = secondaryCTA?.variant === 'primary' ? PrimaryButton : PortfolioButton

  return (
    <div className={`flex h-full gap-4 items-center min-w-full ${className}`}>
      {primaryCTA.to && (
        <PrimaryCTAButton as={StyledInternalLink} to={primaryCTA.to}>
          {primaryCTA.label}
        </PrimaryCTAButton>
      )}
      {secondaryCTA?.to && (
        <SecondaryCTAButton as={StyledInternalLink} to={secondaryCTA.to}>
          {secondaryCTA.label}
        </SecondaryCTAButton>
      )}
    </div>
  )
}
